// extracted by mini-css-extract-plugin
export var navbarSubLink = "H_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "H_t8 d_f0 d_dB";
export var subPageLink = "H_gf d_gf";
export var burger = "H_vS";
export var sublinkSize = "H_vT";
export var linkSize = "H_vV";
export var Link = "H_sW x_sW x_sf x_sz";